
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m7.822 7 2.509-2.503a.586.586 0 0 0-.829-.828L7 6.177 4.497 3.67a.586.586 0 1 0-.828.828L6.177 7 3.67 9.502a.583.583 0 0 0 .19.957.584.584 0 0 0 .638-.128L7 7.822l2.502 2.509a.583.583 0 0 0 .957-.19.583.583 0 0 0-.128-.639L7.822 7z","fill":"#797B86"}})])
          )
        }
      }
    